(function ($) {
  'use strict';

  $(function () {
    function hasVerticalScrollbar() {
      return document.documentElement.scrollHeight > window.innerHeight;
    }

    if(hasVerticalScrollbar()) {
      $('body').addClass('has-vertical-scrollbar');
    }
  });
})(jQuery);